import React from 'react';
import { Alert, Fade } from '@mui/material';
import { ANIMATION_TIMEOUTS, errorAlertStyles } from '../../../constants/manualLogin';

/**
 * ErrorAlert Component
 * Displays error message with fade animation
 */
const ErrorAlert = ({ error }) => {
  if (!error) return null;

  return (
    <Fade in={!!error} timeout={ANIMATION_TIMEOUTS.ERROR_FADE}>
      <Alert severity="error" icon={false} sx={errorAlertStyles}>
        {error}
      </Alert>
    </Fade>
  );
};

export default ErrorAlert;
